import React, { useEffect } from 'react';
import ArticleDeliverySelectProperties from "./ArticleSelectProperties";
import {useStyles} from "./ArticleSelect.style";
import {Observer} from "mobx-react-lite";
import ImageCardSkeletonSkeleton from '../../../../ui_components/Skeletons/ImageCardSkeleton/ImageCardSkeleton';
import SkeletonGrid from '../../../../ui_components/SkeletonGrid/SkeletonGrid';
import { Box, FormControlLabel, Checkbox } from '@material-ui/core';
import Width from '../../../../ui_components/common/enums/Width';
import Alignment from '../../../../ui_components/common/enums/Alignment';
import { useI18nContext } from '../../../../contexts/I18nContext';
import Button from "../../../../ui_components/Button/Button";
import MessageCard from '../../../../ui_components/MessageCard/MessageCard';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import ShowArticleDeliveryItem from '../../../Info/ShowArticleDeliveryItem/ShowArticleDeliveryItem';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Link from '../../../../ui_components/Link/Link';
import ArticleCategorySelect from '../../../Selects/ArticleCategorySelect/ArticleCategorySelect';
import ArticleCategory from '../../../../entities/productOrder/article/ArticleCategory';
import FilterInput from '../../../Inputs/FilterInput/FilterInput';
import ArticleWithPriceResponse from '../../../../model/articleDelivery/ArticleWithPriceResponse';

const ArticleSelect: React.FC<ArticleDeliverySelectProperties> = ({
                                                                          store
                                                                      }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    const [showOnlyInStock, setShowOnlyInStock] = React.useState(false);

    useEffect(() => {
        store.filterByGeo();
    }, [store]);

    const select = (articleId: string) => {
        store.selectArticle(articleId);
    }

    const deSelect = (articleId: string) => {
        store.deselectArticle(articleId);
    }

    const onContactGeoFilter = () => {
        store.geoFilter = store.selectedContact?.geo;
        store.filterByGeo();
    }

    // const onGeoChange = (newGeo: Geo | undefined) => store.geoFilter = newGeo;

    const onCategoryChange = (newCategory?: ArticleCategory) => {
        store.categoryFilter = newCategory;
    }

    const handleStockFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShowOnlyInStock(event.target.checked);
    }

    const getAvailableStock = (article: ArticleWithPriceResponse) => {
        return (article.physicalAmount ?? 0) - (article.assignedAmount ?? 0);
    }

    const getFilteredArticles = () => {
        if (!store.articles) {
            return [];
        }
        
        if (showOnlyInStock) {
            return store.articles.filter((article) => {
                return getAvailableStock(article) > 0;
            });
        }
        
        return store.articles;
    };

    const skeletons = [
        <ImageCardSkeletonSkeleton></ImageCardSkeletonSkeleton>,
        <ImageCardSkeletonSkeleton></ImageCardSkeletonSkeleton>,
        <ImageCardSkeletonSkeleton></ImageCardSkeletonSkeleton>
    ];

    return (
        <Observer>
            {() => {
                const filteredArticles = getFilteredArticles();
                return (<>
                    <Box className={classes.container}>
                        <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                            justifyContent={Alignment.SPACE_BETWEEN}>
                            <div>
                                <FilterInput
                                    className={classes.name_filter}
                                    value={store.nameFilter}
                                    placeholder={i18n.translate("ARTICLE_FILTER_PLACEHOLDER")}
                                    onChange={(value) => {
                                        store.nameFilter = value;
                                    }}/>
                                {store.selectedContact && <div className={classes.contact_geo_select_link_container}>
                                    <Link text={'Filtrar por ubicación del Destinatario'} onClick={onContactGeoFilter}/>
                                </div>}
                                {/* <GeoSelect selected={store.geoFilter} onChange={onGeoChange}/> */}
                                <ArticleCategorySelect
                                    className={classes.category_select}
                                    selected={store.categoryFilter}
                                    fullWidth onChange={onCategoryChange}/>
                                <FormControlLabel
                                    className={classes.stock_filter_checkbox}
                                    control={
                                        <Checkbox
                                            checked={showOnlyInStock}
                                            onChange={handleStockFilterChange}
                                            color="primary"
                                        />
                                    }
                                    label="Mostrar artículos con disponibilidad"
                                />
                                <Button
                                    onClick={() => {
                                        store.filterByGeo()
                                    }}
                                    className={classes.search_btn}
                                    text={i18n.translate("SEARCH")}
                                />
                            </div>
                            <div className={classes.shopping_cart_container}>
                                <div className={classes.shopping_cart_icon_container}><ShoppingCartIcon/></div>
                                {store.selectedArticles && store.selectedArticles.length > 0 && <ul>
                                    {store.selectedArticles.map((selectedArticle, i) => (
                                        <li>
                                            {selectedArticle.name}
                                        </li>
                                    ))}
                                </ul>}
                                {(!store.selectedArticles || store.selectedArticles.length === 0) &&
                                <div className={classes.with_cart_items_text}>Sin artículos en el carrito. Seleccione artículos en el área a la derecha para adicionarlos al carrito.</div>}
                            </div>
                        </Box>
                        <div className={classes.article_container}>
                            {(!filteredArticles || filteredArticles.length === 0) && !store.loadingArticles &&
                                <MessageCard icon={FastfoodIcon} title={i18n.translate("SELECT_A_FILTER_TO_SHOW_ARTICLES")}
                                            subtitle={''}/>}
                            <div>{store.loadingArticles && <SkeletonGrid skeletons={skeletons}></SkeletonGrid>}</div>
                            {!store.loadingArticles && filteredArticles &&
                            filteredArticles.map((el, i) => (
                                <ShowArticleDeliveryItem
                                    key={i}
                                    id={el.id}
                                    title={el.name}
                                    text={el.description}
                                    imageName={el.defaultImage}
                                    articlePrices={el.prices}
                                    stockAvailableAmount={getAvailableStock(el)}
                                    isSelectable={true}
                                    isSelected={store.selectedArticles ? store.selectedArticles.findIndex(t => t.id === el.id) >= 0 : false}
                                    onSelect={select}
                                    onDeselect={deSelect}
                                />
                            ))}
                        </div>
                    </Box>
                </>)
            }}
        </Observer>
    )
}

export default ArticleSelect;
